<template>
  <a-modal
    title="查看变更"
    :visible="visible"
    :mask-closable="false"
    :width="1000"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
    @ok="handleOk('form')"
  >
    <a-table
      :columns="columns"
      :data-source="detailData"
      :loading="loading"
      :pagination="false"
      style="padding: 16px 0; background-color: #fff;"
      :row-key="(item, index) => index"
    >
      <template
        slot="operatorTime"
        slot-scope="operatorTime"
      >
        {{ moment(operatorTime).format('YYYY-MM-DD') }}
      </template>
    </a-table>
  </a-modal>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    detailData: {
      type: Array,
      default: null
    },
    resourceId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      form: {
        baseId: '',
        collectionAmount: '',
        collectionDate: '',
        operateYear: ''
      },
      loading: false,
      columns: [
        {
          title: '操作时间',
          dataIndex: 'operatorTime',
          key: 'operatorTime',
          width: '130px',
          scopedSlots: { customRender: 'operatorTime' }
        },
        {
          title: '操作人',
          dataIndex: 'operator',
          key: 'operator',
          width: '130px'
        },
        {
          title: '操作前内容',
          dataIndex: 'before',
          key: 'before',
          width: '270px'
        },
        {
          title: '操作后内容',
          dataIndex: 'after',
          key: 'after'
        }
      ]
    }
  },
  methods: {
    moment,
    handleCancel () {
      this.$emit('cancel')
    },
    handleOk () {
      this.handleCancel()
    }
  }
}
</script>
